export default {"src":"/_next/static/media/wa-outline-black.54987b7e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};